import React from 'react'
import styled from 'styled-components'

import Colors from '../../commons/Colors'
import { numberFormat } from '../../commons/NumberUtils'

/**
 * Os quatro cards vêm de `response.totals`, calculado no servidor sobre o
 * conjunto filtrado inteiro — nunca somados a partir da página visível, e cada
 * pedido conta uma única vez mesmo com vários produtos.
 */
export default function DetailedOrderReportTotals({ totals }) {
    const cards = [
        {
            testId: 'totals-orders-count',
            label: 'Pedidos',
            value: numberFormat(totals.ordersCount ?? 0, 0),
        },
        {
            testId: 'totals-total-value',
            label: 'Valor total',
            value: numberFormat(totals.totalValue ?? 0, 2, 'R$ '),
        },
        {
            testId: 'totals-total-weight',
            label: 'Peso total (ton)',
            value: numberFormat(totals.totalWeightInTonnes ?? 0, 2),
        },
        {
            testId: 'totals-urgent-count',
            label: 'Pedidos urgentes',
            value: numberFormat(totals.urgentOrdersCount ?? 0, 0),
        },
    ]

    return (
        <Container>
            {cards.map(card => (
                <Card key={card.testId} data-testid={card.testId}>
                    <CardLabel>{card.label}</CardLabel>
                    <CardValue>{card.value}</CardValue>
                </Card>
            ))}
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 16px;
    margin-bottom: 16px;
`

const Card = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${Colors.white};
    border: solid 1px ${Colors.lightBlueGreyFour};
    border-radius: 4px;
    padding: 16px;
`

const CardLabel = styled.span`
    font-family: Roboto;
    font-size: 13px;
    color: ${Colors.brownishGrey};
`

const CardValue = styled.span`
    margin-top: 8px;
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;
    color: ${Colors.black};
`
